export enum LegalPersonType {
  PhysicalPersonNational,
  PhysicalPersonForeign,
  MoralPersonNational,
  MoralPersonForeign,

  PhysicalPersonForeignResidentNational,
  MoralPersonNationalFinanciaryBranch,
  MoralPersonForeignResidentNational,
  EscrowWithRFC,
  EscrowWithoutRFC,
  PublicEntityNationalOfPublicLaw,
  PublicEntityBranchOfFederalSecretariats,
  PublicEntityNational,
  PublicEntityForeignResidentNational,
  PublicEntityForeign,
  NA,
}

export const legalPersonTypeValues: { [id: number]: string } = {
  0: 'Persona física nacional',
  1: 'Persona física extranjera con residencia en el extranjero',
  2: 'Persona moral nacional',
  3: 'Persona moral extranjera con residencia en el extranjero',

  4: 'Persona física extranjera con residencia en México',
  5: 'Régimen de identificación simplificado',
  6: 'Persona moral extranjera con residencia en México',

  7: 'Fideicomiso con RFC',
  8: 'Fideicomiso sin RFC',
  9: 'Persona moral nacional de derecho público',
  10: 'Secretaría federal',
  11: 'Dependencias y entidades públicas',
  12: 'Embajada, consulado u organismo internacional con residencia en Mexico',
  13: 'Embajada, consulado u organismo internacional con residencia en el extranjero',
  14: 'NA',
};

export namespace LegalPersonType {
  export function values() {
    return Object.keys(LegalPersonType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: legalPersonTypeValues[index], value: index };
      });
  }
}
